import { render, staticRenderFns } from "./web-ad-audience.vue?vue&type=template&id=612993b2&scoped=true&"
import script from "./web-ad-audience.vue?vue&type=script&lang=js&"
export * from "./web-ad-audience.vue?vue&type=script&lang=js&"
import style0 from "./web-ad-audience.vue?vue&type=style&index=0&id=612993b2&lang=scss&scoped=true&"
import style1 from "./web-ad-audience.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612993b2",
  null
  
)

export default component.exports